import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

export default function VerifyEmailPage() {
  const [search] = useSearchParams();
  const token = search.get("token");
  const [status, setStatus] = useState("verifying");
  const [msg, setMsg] = useState("Memverifikasi email Anda...");
  const nav = useNavigate();

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Tautan tidak valid"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => { setStatus("ok"); setMsg("Email Anda berhasil diverifikasi."); })
      .catch(err => { setStatus("error"); setMsg(formatApiError(err.response?.data?.detail) || "Gagal memverifikasi email"); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="bg-white rounded-lg shadow-md p-8 w-full max-w-md text-center">
        <img src="/logo-gema.png" alt="GEMA" className="w-16 h-16 rounded-xl object-cover mx-auto mb-4"/>
        <div className="font-heading text-lg font-bold text-slate-900">Verifikasi Email</div>
        <div className={`mt-4 text-sm ${status==="ok"?"text-green-600":status==="error"?"text-red-600":"text-slate-500"}`} data-testid="verify-status">
          {status==="ok" && "✓ "}
          {status==="error" && "✕ "}
          {msg}
        </div>
        <button onClick={()=>nav(status==="ok"?"/":"/login")} className="mt-6 w-full py-2 bg-[#00558F] hover:bg-[#003E6B] text-white rounded-md">Lanjutkan</button>
      </div>
    </div>
  );
}
